// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManagePaymentGateway-space1-m60Li {
	margin-bottom: 6px !important;
}

.ManagePaymentGateway-space2-Ar28I {
	margin-bottom: 12px !important;
}

.ManagePaymentGateway-space3-RVayP {
	margin-bottom: 18px !important;
}

.ManagePaymentGateway-space4-HJt9A {
	margin-bottom: 24px !important;
}

.ManagePaymentGateway-space5-Yf2M6 {
	margin-bottom: 30px !important;
}

.ManagePaymentGateway-space6-_slk3 {
	margin-bottom: 36px !important;
}

.ManagePaymentGateway-space7-NhnOS {
	margin-bottom: 42px !important;
}

.ManagePaymentGateway-space8-H56t7 {
	margin-bottom: 48px !important;
}

.ManagePaymentGateway-spaceTop1-Qg2pE {
	margin-top: 6px !important;
}

.ManagePaymentGateway-spaceTop2-NYRhV {
	margin-top: 12px !important;
}

.ManagePaymentGateway-spaceTop3-Ik7Xp {
	margin-top: 18px !important;
}

.ManagePaymentGateway-spaceTop4-Sj05I {
	margin-top: 24px !important;
}

.ManagePaymentGateway-spaceTop5-LXXo5 {
	margin-top: 30px !important;
}

.ManagePaymentGateway-spaceTop6-Sdvse {
	margin-top: 36px !important;
}

.ManagePaymentGateway-spaceTop7-YpsKO {
	margin-top: 42px !important;
}

.ManagePaymentGateway-spaceTop8-yaJUe {
	margin-top: 48px !important;
}

.ManagePaymentGateway-noMargin-zVCxJ {
	margin: 0px !important;
}

.ManagePaymentGateway-padding1-UuPnF {
	padding-bottom: 6px !important;
}

.ManagePaymentGateway-padding2-LWxul {
	padding-bottom: 12px !important;
}

.ManagePaymentGateway-padding3-qb2uw {
	padding-bottom: 18px !important;
}

.ManagePaymentGateway-padding4-JdrwZ {
	padding-bottom: 24px !important;
}

.ManagePaymentGateway-padding5-JzPbI {
	padding-bottom: 30px !important;
}

.ManagePaymentGateway-padding6-GCSRJ {
	padding-bottom: 36px !important;
}

.ManagePaymentGateway-padding7-o3vr3 {
	padding-bottom: 42px !important;
}

.ManagePaymentGateway-paddingTop1-Eyjte {
	padding-top: 6px !important;
}

.ManagePaymentGateway-paddingTop2-GH40k {
	padding-top: 12px !important;
}

.ManagePaymentGateway-paddingTop3-PrQec {
	padding-top: 18px !important;
}

.ManagePaymentGateway-paddingTop4-M_3TS {
	padding-top: 24px !important;
}

.ManagePaymentGateway-paddingTop5-tLG08 {
	padding-top: 30px !important;
}

.ManagePaymentGateway-paddingTop6-nJ2qY {
	padding-top: 36px !important;
}

.ManagePaymentGateway-paddingTop7-kd5fy {
	padding-top: 42px !important;
}

.ManagePaymentGateway-noPadding-ZqOYA {
	padding: 0px !important;
}

.ManagePaymentGateway-spaceMarginBottom0-I10yJ {
	margin-bottom: 0;
}

.ManagePaymentGateway-textBold-MTPnW {
	font-weight: 500 !important;
}

.ManagePaymentGateway-textBolder-XDts8 {
	font-weight: 700 !important;
}

.ManagePaymentGateway-textNormal-R1ASR {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ManagePaymentGateway-textDarkBlue-jM6OU {
	color: rgb(20, 39, 94) !important;
}

.ManagePaymentGateway-textLightBlue-thEeW {
	color: rgb(57, 87, 106) !important;
}

.ManagePaymentGateway-textLightSandleGreen-kjR7u {
	color: rgb(76, 86, 41) !important;
}

.ManagePaymentGateway-textLightBrown-AcIix {
	color: rgb(115, 79, 33) !important;
}

.ManagePaymentGateway-textMediumMaroon-v8bQc {
	color: rgb(87, 37, 51) !important;
}

.ManagePaymentGateway-textBrown-Kbbxt {
	color: rgb(160, 47, 24) !important;
}

.ManagePaymentGateway-textMaroon-GNjIz {
	color: rgb(155, 49, 67) !important;
}

.ManagePaymentGateway-textDarkBrown-dHpTa {
	color: rgb(83, 18, 16) !important;
}

.ManagePaymentGateway-textMediumBrown-lzvcx {
	color: rgb(142, 28, 10) !important;
}

.ManagePaymentGateway-textSkyBlue-mDghL {
	color: rgb(37, 117, 141) !important;
}

.ManagePaymentGateway-textGray-jWuuu {
	color: rgb(77, 65, 51) !important;
}

.ManagePaymentGateway-errorMessage-vPQDn {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ManagePaymentGateway-userText-eQKth {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ManagePaymentGateway-panelHeader-BHINQ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ManagePaymentGateway-exportSection-ngRh_ {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ManagePaymentGateway-exportSectionGridSub-BbdNy {
	grid-template-columns: 50% 49% !important;
}

.ManagePaymentGateway-exportText-bBWsM {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ManagePaymentGateway-exportLinkImg-GGHGU {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ManagePaymentGateway-exportImg-G9bC6 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ManagePaymentGateway-linkBtn-JO92j {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ManagePaymentGateway-table-ZqQwZ {
	display: table;
}

.ManagePaymentGateway-tableRow-XrYCv {
	display: table-row;
}

.ManagePaymentGateway-tableCell-OKdYH {
	display: table-cell;
	float: none;
}

.ManagePaymentGateway-formGroup-_I2jL {
	margin-bottom: 6px;
}

.ManagePaymentGateway-marginTop0-rC1tb {
	margin-top: 0;
}

.ManagePaymentGateway-marginBottom20-RHBMA {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ManagePaymentGateway-bannerImageBg-d9iZ_ {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ManagePaymentGateway-bannerDelete-RWylj {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ManagePaymentGateway-exportLink-SV3bM {
	padding-top: 10px;
	padding-right: 10px;
}

.ManagePaymentGateway-seachContent-dsQAw {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ManagePaymentGateway-marginBottom9-NMl3h {
	margin-bottom: 9px;
}

.ManagePaymentGateway-spaceTop52-aiJsK {
	margin-top: 52px;
}

.ManagePaymentGateway-profileViewInner-ay6_6 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ManagePaymentGateway-profileViewMain-LcLmb {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ManagePaymentGateway-profileViewlabel-KN3ot {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ManagePaymentGateway-profileViewMainContent-P4DRR {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ManagePaymentGateway-reviewsFormStar-MPQaZ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ManagePaymentGateway-reviewsFormStar-MPQaZ svg {
	cursor: pointer;
}

.ManagePaymentGateway-addLanguageText-pX1_2 {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ManagePaymentGateway-exportSection-ngRh_ {
		grid-template-columns: 100%;
	}

	.ManagePaymentGateway-spaceTop52-aiJsK {
		margin-top: 18px;
	}

	.ManagePaymentGateway-exportText-bBWsM {
		float: none;
		margin-top: 12px;
	}

	.ManagePaymentGateway-exportSectionGridSub-BbdNy {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ManagePaymentGateway-profileViewlabel-KN3ot {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ManagePaymentGateway-profileViewMainContent-P4DRR {
		width: 100%;
		text-align: center;
	}

	.ManagePaymentGateway-panelHeader-BHINQ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ManagePaymentGateway-space1-m60Li`,
	"space2": `ManagePaymentGateway-space2-Ar28I`,
	"space3": `ManagePaymentGateway-space3-RVayP`,
	"space4": `ManagePaymentGateway-space4-HJt9A`,
	"space5": `ManagePaymentGateway-space5-Yf2M6`,
	"space6": `ManagePaymentGateway-space6-_slk3`,
	"space7": `ManagePaymentGateway-space7-NhnOS`,
	"space8": `ManagePaymentGateway-space8-H56t7`,
	"spaceTop1": `ManagePaymentGateway-spaceTop1-Qg2pE`,
	"spaceTop2": `ManagePaymentGateway-spaceTop2-NYRhV`,
	"spaceTop3": `ManagePaymentGateway-spaceTop3-Ik7Xp`,
	"spaceTop4": `ManagePaymentGateway-spaceTop4-Sj05I`,
	"spaceTop5": `ManagePaymentGateway-spaceTop5-LXXo5`,
	"spaceTop6": `ManagePaymentGateway-spaceTop6-Sdvse`,
	"spaceTop7": `ManagePaymentGateway-spaceTop7-YpsKO`,
	"spaceTop8": `ManagePaymentGateway-spaceTop8-yaJUe`,
	"noMargin": `ManagePaymentGateway-noMargin-zVCxJ`,
	"padding1": `ManagePaymentGateway-padding1-UuPnF`,
	"padding2": `ManagePaymentGateway-padding2-LWxul`,
	"padding3": `ManagePaymentGateway-padding3-qb2uw`,
	"padding4": `ManagePaymentGateway-padding4-JdrwZ`,
	"padding5": `ManagePaymentGateway-padding5-JzPbI`,
	"padding6": `ManagePaymentGateway-padding6-GCSRJ`,
	"padding7": `ManagePaymentGateway-padding7-o3vr3`,
	"paddingTop1": `ManagePaymentGateway-paddingTop1-Eyjte`,
	"paddingTop2": `ManagePaymentGateway-paddingTop2-GH40k`,
	"paddingTop3": `ManagePaymentGateway-paddingTop3-PrQec`,
	"paddingTop4": `ManagePaymentGateway-paddingTop4-M_3TS`,
	"paddingTop5": `ManagePaymentGateway-paddingTop5-tLG08`,
	"paddingTop6": `ManagePaymentGateway-paddingTop6-nJ2qY`,
	"paddingTop7": `ManagePaymentGateway-paddingTop7-kd5fy`,
	"noPadding": `ManagePaymentGateway-noPadding-ZqOYA`,
	"spaceMarginBottom0": `ManagePaymentGateway-spaceMarginBottom0-I10yJ`,
	"textBold": `ManagePaymentGateway-textBold-MTPnW`,
	"textBolder": `ManagePaymentGateway-textBolder-XDts8`,
	"textNormal": `ManagePaymentGateway-textNormal-R1ASR`,
	"textDarkBlue": `ManagePaymentGateway-textDarkBlue-jM6OU`,
	"textLightBlue": `ManagePaymentGateway-textLightBlue-thEeW`,
	"textLightSandleGreen": `ManagePaymentGateway-textLightSandleGreen-kjR7u`,
	"textLightBrown": `ManagePaymentGateway-textLightBrown-AcIix`,
	"textMediumMaroon": `ManagePaymentGateway-textMediumMaroon-v8bQc`,
	"textBrown": `ManagePaymentGateway-textBrown-Kbbxt`,
	"textMaroon": `ManagePaymentGateway-textMaroon-GNjIz`,
	"textDarkBrown": `ManagePaymentGateway-textDarkBrown-dHpTa`,
	"textMediumBrown": `ManagePaymentGateway-textMediumBrown-lzvcx`,
	"textSkyBlue": `ManagePaymentGateway-textSkyBlue-mDghL`,
	"textGray": `ManagePaymentGateway-textGray-jWuuu`,
	"errorMessage": `ManagePaymentGateway-errorMessage-vPQDn`,
	"userText": `ManagePaymentGateway-userText-eQKth`,
	"panelHeader": `ManagePaymentGateway-panelHeader-BHINQ`,
	"exportSection": `ManagePaymentGateway-exportSection-ngRh_`,
	"exportSectionGridSub": `ManagePaymentGateway-exportSectionGridSub-BbdNy`,
	"exportText": `ManagePaymentGateway-exportText-bBWsM`,
	"exportLinkImg": `ManagePaymentGateway-exportLinkImg-GGHGU`,
	"exportImg": `ManagePaymentGateway-exportImg-G9bC6`,
	"linkBtn": `ManagePaymentGateway-linkBtn-JO92j`,
	"table": `ManagePaymentGateway-table-ZqQwZ`,
	"tableRow": `ManagePaymentGateway-tableRow-XrYCv`,
	"tableCell": `ManagePaymentGateway-tableCell-OKdYH`,
	"formGroup": `ManagePaymentGateway-formGroup-_I2jL`,
	"marginTop0": `ManagePaymentGateway-marginTop0-rC1tb`,
	"marginBottom20": `ManagePaymentGateway-marginBottom20-RHBMA`,
	"bannerImageBg": `ManagePaymentGateway-bannerImageBg-d9iZ_`,
	"bannerDelete": `ManagePaymentGateway-bannerDelete-RWylj`,
	"exportLink": `ManagePaymentGateway-exportLink-SV3bM`,
	"seachContent": `ManagePaymentGateway-seachContent-dsQAw`,
	"marginBottom9": `ManagePaymentGateway-marginBottom9-NMl3h`,
	"spaceTop52": `ManagePaymentGateway-spaceTop52-aiJsK`,
	"profileViewInner": `ManagePaymentGateway-profileViewInner-ay6_6`,
	"profileViewMain": `ManagePaymentGateway-profileViewMain-LcLmb`,
	"profileViewlabel": `ManagePaymentGateway-profileViewlabel-KN3ot`,
	"profileViewMainContent": `ManagePaymentGateway-profileViewMainContent-P4DRR`,
	"reviewsFormStar": `ManagePaymentGateway-reviewsFormStar-MPQaZ`,
	"addLanguageText": `ManagePaymentGateway-addLanguageText-pX1_2`
};
module.exports = ___CSS_LOADER_EXPORT___;
